const deviveIp = '192.168.5.119:6856';

export default deviveIp;
